import { render, staticRenderFns } from "./extras-header.vue?vue&type=template&id=d5ad6d00&"
import script from "./extras-header.vue?vue&type=script&lang=js&"
export * from "./extras-header.vue?vue&type=script&lang=js&"
import style0 from "./extras-header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports